{
  "version": 1,
  "asset_id": "03f18148-d2a5-4ddf-aed8-60001e6e227c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/03f18148-d2a5-4ddf-aed8-60001e6e227c/loc-san-antonio-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/03f18148-d2a5-4ddf-aed8-60001e6e227c/loc-san-antonio-640.avif",
  "original_filename": "loc-san-antonio-640.avif",
  "size": 24378,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:34Z"
}
